<template>
  <el-form @submit.native.prevent="$emit('submit')">
    <el-form-item class="mb-1">
      <el-input
        v-model="e"
        placeholder="Enter email"
        :disabled="usingSSO"
        clearable
      />
    </el-form-item>

    <el-form-item class="mb-0">
      <el-input
        v-model="p"
        placeholder="Enter password"
        show-password
        :disabled="usingSSO"
        @keyup.enter.native="$emit('submit')"
      />
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    email: {
      type: String,
      required: true
    },
    password: {
      type: String,
      required: true
    },
    sso: {
      type: String,
      required: true
    }
  },
  computed: {
    usingSSO: function () {
      // eslint-disable-next-line
      return this.sso && this.sso !== '' ? true : false
    },
    e: {
      get: function () {
        return this.email
      },
      set: function (value) {
        this.$emit('update:email', value)
      }
    },
    p: {
      get: function () {
        return this.password
      },
      set: function (value) {
        this.$emit('update:password', value)
      }
    }
  }
}
</script>
